// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectActivityMaterialTabularImportApi {
	export async function importLines(args: {
		projectActivityId: number;
		fileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/import/tabular/importLines",
			method: "POST",
			data: {
				projectActivityId: args.projectActivityId,
				fileHandle: args.fileHandle,
			},
		});
		return response as void;
	}
}
